import React from 'react';

function Footer() {
  return (
    <footer
      id="footer"
      className="relative border-t border-ink-100 bg-grad-footer"
    >
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8 items-start">
          {/* Branding */}
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-grad-brand-accent text-white font-bold text-sm shadow-sm">
                S
              </span>
              <span className="font-semibold text-ink-900">SSAH</span>
            </div>
            <p className="mt-3 text-sm text-ink-500 leading-relaxed">
              Superficial Safety Alignment Hypothesis &mdash; a project from
              Kim Lab at NC State.
            </p>
          </div>

          {/* Links */}
          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-ink-500">
              Resources
            </div>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <a
                  href="https://arxiv.org/abs/2410.10862"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink-700 hover:text-brand-700 transition-colors"
                >
                  → Paper on arXiv
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/JEKimLab/SSAH"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink-700 hover:text-brand-700 transition-colors"
                >
                  → Code on GitHub
                </a>
              </li>
              <li>
                <a
                  href="#citation"
                  className="text-ink-700 hover:text-brand-700 transition-colors"
                >
                  → Cite this work
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-ink-500">
              Contact
            </div>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <a
                  href="mailto:jli265@ncsu.edu"
                  className="text-ink-700 hover:text-brand-700 transition-colors"
                >
                  jli265@ncsu.edu
                </a>
              </li>
              <li>
                <a
                  href="mailto:jung-eun.kim@ncsu.edu"
                  className="text-ink-700 hover:text-brand-700 transition-colors"
                >
                  jung-eun.kim@ncsu.edu
                </a>
              </li>
              <li className="text-ink-500">
                Dept. of Computer Science, NC State University
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-ink-100 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-xs text-ink-500">
            © {new Date().getFullYear()} Kim Lab. All rights reserved.
          </p>
          <p className="text-xs text-ink-400">
            Built with React &amp; Tailwind CSS.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
